import React, { Component } from "react";
import { Modal, Form, Input, Button, InputNumber } from "antd";
import { injectIntl } from "react-intl";
import "./index.styl";

class StubParamPriceModal extends Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = {
            valueList: [],
        };
        // 计费规则form
        this.formRef = React.createRef();
    }

    handleOk = () => {
       // 校验参数
       const { validateFields } = this.formRef.current;
       validateFields().then((values) => {
        console.log(values);
        let elePrice = "";
        let serverPrice = "";
        let time = "";
        // let type = "";
        const num = `${this.state.valueList.length}`;
        this.state.valueList.forEach((item, index) => {
         elePrice = index === this.state.valueList.length - 1 ? elePrice + values[`elePrice${item}`] : `${elePrice + values[`elePrice${item}`]}|`;
         serverPrice = index === this.state.valueList.length - 1 ? serverPrice + values[`serverPrice${item}`] : `${serverPrice + values[`serverPrice${item}`]}|`;
         time = index === this.state.valueList.length - 1 ? time + values[`time${item}`] : `${time + values[`time${item}`]}|`;
        // type = index === this.state.valueList.length - 1 ?
        // type + values[`type${item}`] : `${type + values[`type${item}`]}|`;
        });
        const returnValue = {
         num: num,
         elePrice: elePrice,
         serverPrice: serverPrice,
         time: time,
        //  type: type,
        };
        this.props.okFunction(returnValue);
        this.setState({
            valueList: [0],
        });
       });
    }

    addForm = () => {
        const list = [...this.state.valueList, this.state.valueList.length];
        this.setState({
            valueList: list,
        });
    }

    delForm = (index) => {
        const values = this.formRef.current.getFieldsValue();
        delete values[`elePrice${index}`];
        delete values[`serverPrice${index}`];
        delete values[`time${index}`];
        // delete values[`type${index}`];
        this.formRef.current.setFieldsValue(values);
        const list = [...this.state.valueList];
        list.splice(index, 1);
        this.setState({
            valueList: list,
        });
    }

    // 校验时间
    validatorTime = (_, value) => {
        const numTest = /[0-9]$/;
        if (value && value.length !== 4) {
            return Promise.reject(new Error("请输入4位数字"));
        } else if (value && !numTest.test(value)) {
            return Promise.reject(new Error("请输入数字"));
        }
        return Promise.resolve();
    }

    render() {
        if (this.state.valueList.length < 1) {
            this.setState({
                valueList: [0],
            });
        }
        return <Modal
          destroyOnClose
          visible={this.props.visible}
          title="计费规则修改"
          width={1000}
          onOk={this.handleOk}
          onCancel={() => {
                this.setState({ valueList: [0] });
                this.props.onCancel();
            }}>
            <div>
                <Form validateMessages={{ default: "" }} preserve={false} validateTrigger="onBlur" validateFirst ref={this.formRef}>
                    {
                        this.state.valueList.map((item, index) => <div className="price-form-group">
                              <Form.Item rules={[{ required: true, message: "请输入电费" }]} name={`elePrice${item}`} label="电费">
                                  <InputNumber min={0} precision={2} style={{ width: 100 }} />
                              </Form.Item>
                              <Form.Item rules={[{ required: true, message: "请输入服务费" }]} name={`serverPrice${item}`} label="服务费">
                                  <InputNumber min={0} precision={2} style={{ width: 100 }} />
                              </Form.Item>
                              <Form.Item rules={[{ required: true, message: "请输入时间" }, { validator: this.validatorTime }]} name={`time${item}`} label="时间">
                                  <Input style={{ width: 100 }} />
                              </Form.Item>
                              {/* <Form.Item rules={[{ required: true, message: "请选择峰尖谷平" }]}
                                  name={`type${item}`} label="峰尖谷平">
                                  <Select style={{ width: 100 }}>
                                      <Select.Option key="1" value="1">峰</Select.Option>
                                      <Select.Option key="2" value="2">尖</Select.Option>
                                      <Select.Option key="3" value="3">谷</Select.Option>
                                      <Select.Option key="4" value="4">平</Select.Option>
                                  </Select>
                              </Form.Item> */}
                              {
                                  index === 0 ? <Button type="primary" onClick={this.addForm}>添加</Button> : <Button type="primary" onClick={() => { this.delForm(index); }}>删除</Button>
                              }
                                                                  </div>)
                    }
                </Form>
                <div style={{ color: "red" }}>注：时间为4位数字，比如1330表示13点30分</div>
            </div>
               </Modal>;
    }
}

export default injectIntl(StubParamPriceModal);



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/stub/stubParamPriceModal.js